import React from "react";
import { LinkedinLogo, Medal } from "@phosphor-icons/react";
import { useI18n } from "../../i18n/I18nContext";

const MEMBER_META = [
  {
    id: "team-olga",
    img: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/2a60hkph_7c5f8b9d121ef0e52a72af14ea6e8529f62d897c.png",
    objectPosition: "center 28%",
  },
  {
    id: "team-dmitry",
    img: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/qabuq8ow_efafe194fed7b4fccd176cc28ac84ced4ee8cb09.png",
    objectPosition: "center 30%",
  },
  {
    id: "team-andrey",
    img: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/ogimv2yh_Andy.png",
    objectPosition: "center 25%",
  },
  {
    id: "team-maxim",
    img: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/pm26xerx_5267010926320229361.jpg",
    objectPosition: "center 22%",
  },
  {
    id: "team-anton",
    img: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/vgjpnlz7_5bui0c9s_Anton.png",
    objectPosition: "center 20%",
  },
];

export const Team = () => {
  const { t } = useI18n();

  return (
    <section id="team" data-testid="team-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-14">
          <div className="mono text-xs uppercase tracking-[0.22em] text-brand-cyan mb-3">
            {t.team.sectionNum}
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight max-w-3xl">
            {t.team.headlinePart1}
            <br />
            <span className="text-muted">{t.team.headlinePart2}</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.team.members.map((m, idx) => {
            const meta = MEMBER_META[idx] || MEMBER_META[0];
            return (
              <div
                key={meta.id}
                data-testid={meta.id}
                className="group glass rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300 flex flex-col"
              >
                <div className="relative w-full h-72 overflow-hidden flex-shrink-0">
                  <img
                    src={meta.img}
                    alt={m.name}
                    style={{ objectPosition: meta.objectPosition }}
                    className="absolute inset-0 w-full h-full object-cover grayscale-[30%] saturate-[0.9] group-hover:grayscale-0 group-hover:saturate-100 transition-all duration-500"
                    loading="lazy"
                    data-testid={`${meta.id}-photo`}
                  />
                  <div
                    className="absolute inset-0 mix-blend-overlay"
                    style={{
                      background:
                        "linear-gradient(135deg, rgba(0,80,230,0.25) 0%, rgba(0,0,0,0) 40%, rgba(0,153,201,0.18) 100%)",
                    }}
                  />
                  <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-white/95 via-white/40 to-transparent" />
                  <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2 py-1 rounded-full bg-white/85 border border-ink-text/10 backdrop-blur-sm mono text-[9px] uppercase tracking-widest text-brand">
                    <span className="w-1 h-1 rounded-full bg-brand-cyan shadow-[0_0_6px_#0099C9]" />
                    {m.tag.split(" · ")[0]}
                  </div>
                </div>

                <div className="flex-1 p-7">
                  <div className="font-heading text-2xl font-bold tracking-tight">{m.name}</div>
                  <div className="mt-1 mono text-xs uppercase tracking-widest text-brand-cyan">
                    {m.role}
                  </div>
                  <ul className="mt-5 space-y-2.5">
                    {m.bullets.map((b, i) => (
                      <li key={i} className="flex items-start gap-2.5 text-sm text-muted">
                        <Medal size={14} weight="duotone" className="text-brand-cyan mt-0.5 flex-shrink-0" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-6 inline-flex items-center gap-2 text-xs text-muted">
                    <LinkedinLogo size={14} weight="fill" />
                    <span className="mono uppercase tracking-widest">{m.tag}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Team;
